/**
 * Mock-Daten für die Brand-Dashboard-View.
 * Realer Endpoint: `GET /v1/admin/stats`.
 *
 * Stand 2026-06 — Live liefert genau diese flache Shape (kein YTD/Trend,
 * kein Uptime). Wenn der Endpoint später erweitert wird, hier + im
 * `normalizeStats()` im Hook nachziehen.
 */

export function brandStatsFixture(brandOrigin = 'valikey.app') {
  return {
    revenue: {
      paidCount: 47,
      paidTotal: '4123.55',  // Server liefert Strings
      totalOrders: 52,
      currency: 'EUR',
    },
    users: {
      totalUsers: 12,
      activeUsers: '11',     // Server liefert Strings
      suspendedUsers: '1',
    },
    services: {
      total: 8,
      active: 7,
      suspended: 0,
      failed: 1,
    },
    generatedAt: new Date().toISOString(),
    _brandOrigin: brandOrigin,
  };
}
